import { FiltersVisibilityButton, Loader, Table, type TableColumnPinning } from '@lifebit-ai/lds'
import React from 'react'

import { TablePaginationContainer, TableWrapper } from 'core/Common.styles'
import {
  EmptyStateContainer,
  LoadingContainer
} from 'modules/requests/ExportAndAccessRequestsTable/RequestsTable.styles'
import * as styles from 'modules/requests/ExportAndAccessRequestsTable/RequestsTable.styles'
import { DataAccessRequestAssigneeFilter } from 'modules/requests/data-access-requests/DataAccessRequestAssigneeFilter'
import { DataAccessRequestLabelsFilter } from 'modules/requests/data-access-requests/DataAccessRequestLabelsFilter'
import { DataAccessRequestRequestedByFilter } from 'modules/requests/data-access-requests/DataAccessRequestRequestedByFilter'
import { DataAccessRequestWorkspacesFilter } from 'modules/requests/data-access-requests/DataAccessRequestWorkspacesFilter'
import { DataAccessRequestDatasetFilter } from 'modules/requests/data-access-requests/filters/DataAccessRequestDatasetFilter'
import { DataAccessRequestStatusFilter } from 'modules/requests/data-access-requests/filters/DataAccessRequestStatusFilter'
import { useDataAccessRequestsTablePage } from 'modules/requests/data-access-requests/hooks/useDataAccessRequestsTablePage'
import type { DataAccessRequestVerificationListItem } from 'services/data-access-requests/types'

export const DATA_ACCESS_REQUESTS_TABLE_WRAPPER_TEST_ID = 'data-access-requests-table-wrapper-test-id'
export const DATA_ACCESS_REQUESTS_LOADING_CONTAINER_TEST_ID = 'data-access-requests-loading-container-test-id'

const DATA_ACCESS_REQUESTS_TABLE_PINNING: TableColumnPinning = {
  current: ['status', 'studyId'],
  onChange: () => {}
}

const LoadingIcon = () => {
  return (
    <LoadingContainer data-testid={DATA_ACCESS_REQUESTS_LOADING_CONTAINER_TEST_ID}>
      <Loader text={false} />
    </LoadingContainer>
  )
}

const DataAccessRequestsTable = () => {
  const {
    activeFiltersCount,
    applyCheckboxFilter,
    applySearchFilter,
    areFiltersVisible,
    columns,
    dataAccessRequests,
    openDataAccessRequest,
    isLoading,
    resetCheckboxFilter,
    resetSearchFilter,
    showPagination,
    tablePagination,
    toggleFiltersVisibility
  } = useDataAccessRequestsTablePage()

  return (
    <TableWrapper data-testid={DATA_ACCESS_REQUESTS_TABLE_WRAPPER_TEST_ID}>
      <Table<DataAccessRequestVerificationListItem>
        rowKey="_id"
        data-testid="data-access-requests-table"
        columns={columns}
        data={dataAccessRequests}
        onRowClicked={(_, row) => {
          void openDataAccessRequest(row.original._id)
        }}
        loading={isLoading}
        loadingIcon={<LoadingIcon />}
        emptyComponent={<EmptyStateContainer>No data access requests found</EmptyStateContainer>}
        pagination={tablePagination}
        pinning={DATA_ACCESS_REQUESTS_TABLE_PINNING}
      >
        <styles.FiltersVisibilityButtonWrapper>
          <FiltersVisibilityButton
            areFiltersVisible={areFiltersVisible}
            numActiveFilters={activeFiltersCount}
            onClick={toggleFiltersVisibility}
          />
        </styles.FiltersVisibilityButtonWrapper>
        {areFiltersVisible && (
          <styles.FiltersContainer>
            <DataAccessRequestStatusFilter
              onApply={applyCheckboxFilter('status')}
              onReset={resetCheckboxFilter('status')}
            />
            <DataAccessRequestDatasetFilter onApply={applySearchFilter} onReset={resetSearchFilter} />
            <DataAccessRequestLabelsFilter
              onApply={applyCheckboxFilter('labelIds')}
              onReset={resetCheckboxFilter('labelIds')}
            />
            <DataAccessRequestWorkspacesFilter
              onApply={applyCheckboxFilter('workspaceIds')}
              onReset={resetCheckboxFilter('workspaceIds')}
            />
            <DataAccessRequestRequestedByFilter
              onApply={applyCheckboxFilter('requesterIds')}
              onReset={resetCheckboxFilter('requesterIds')}
            />
            <DataAccessRequestAssigneeFilter
              onApply={applyCheckboxFilter('assigneeIds')}
              onReset={resetCheckboxFilter('assigneeIds')}
            />
          </styles.FiltersContainer>
        )}
        <Table.TableContainer>
          <Table.Body />
          {showPagination ? (
            <TablePaginationContainer>
              <Table.Pagination />
            </TablePaginationContainer>
          ) : null}
        </Table.TableContainer>
      </Table>
    </TableWrapper>
  )
}

export default DataAccessRequestsTable
